export const environment = {
  environment: 'Development',
  // apiUrl: 'https://mealdynamicsqavm.northcentralus.cloudapp.azure.com',
  apiUrl: 'https://devapi.mealdynamics.com',
  // apiUrl: 'https://api.mealdynamics.com',
  dashboardApiUrl:
    'https://md-dashboard-dev.victoriousdune-84782a1e.eastus.azurecontainerapps.io',
  encryptionKey: 'n7qiB4HZJT1OTPNeKyQqzrvCuNTR4pVCGS7bfH3g3ko=',
  companyId: '6deb6dd8-ed1f-4ae6-8285-5a876d7fe5f9',
  assetUser: '318B63B9-BE09-47EF-9B01-779AD8B1228A',
  categoryId: 'fe900b63-2502-4072-bcd8-62e7d444687a',

  ocrUrl: 'https://uatapi.mealdynamics.com:4433',

  // Agent service — proxied to localhost:3002 via proxy.conf.json
  agentUrl: 'https://uat-mdai.mealdynamics.com/v1/agent',
  vendorPaymentDetailsEnabled: false,
};

export const firebaseConfig = {
  apiKey: 'AIzaSyDZ8sJ1nB5YnVZDDTmMDp5Wri6l_72NvA8',
  authDomain: 'meal-dynamics.firebaseapp.com',
  projectId: 'meal-dynamics',
  storageBucket: 'meal-dynamics.appspot.com',
  messagingSenderId: '438192111090',
  appId: '1:438192111090:web:db1bd68e0bc754b7f6ff6b',
  measurementId: 'G-WK7VQ8503D',
  vapidKey:
    'BDOV-OiqHwowOROYkGG7WQpKm6c6WxRgLwa8qwfJYx3RRhEIUftyP4jb3NC5v_C5Tvib4epS-w9_h9Zege3OoYA',
};
